export const fitmentData = {

  Yamaha: {

    2025: [
      "FX SVHO",
      "FX Cruiser SVHO",
      "GP SVHO",
      "JetBlaster",
      "SuperJet",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VX-C",
      "VX"
    ],

    2024: [
      "FX SVHO",
      "FX Cruiser SVHO",
      "GP SVHO",
      "JetBlaster",
      "SuperJet",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VX-C",
      "VX"
    ],

    2023: [
      "FX SVHO",
      "FX Cruiser SVHO",
      "GP1800R SVHO",
      "JetBlaster",
      "SuperJet",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VX-C",
      "VX"
    ],

    2022: [
      "FX SVHO",
      "FX Cruiser SVHO",
      "GP1800R SVHO",
      "JetBlaster",
      "SuperJet",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VX-C",
      "VX"
    ],

    2021: [
      "FX SVHO",
      "FX Cruiser SVHO",
      "GP1800R SVHO",
      "SuperJet",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VX-C",
      "VX"
    ],

    2020: [
      "FX SVHO",
      "FX Cruiser SVHO",
      "GP1800R HO",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VX-C",
      "VX"
    ],

    2019: [
      "EX Deluxe",
      "EX-R",
      "EX",
      "FX Cruiser HO",
      "FX Cruiser SVHO",
      "FX HO",
      "FX SVHO",
      "GP1800R",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VXR"
    ],

    2018: [
      "EX Deluxe",
      "EX-R",
      "EX",
      "FX Cruiser SVHO",
      "FX SVHO",
      "GP1800",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VXR",
      "VXS"
    ],

    2017: [
      "EX Deluxe",
      "EX",
      "FX Cruiser SVHO",
      "FX SVHO",
      "GP1800",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VXR",
      "VXS"
    ],

    2016: [
      "FX Cruiser SVHO",
      "FX SVHO",
      "FX Cruiser HO",
      "FX HO",
      "FZR",
      "FZS",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VXR",
      "VXS"
    ],

    2015: [
      "FX Cruiser SVHO",
      "FX SVHO",
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "FZR",
      "FZS",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Cruiser HO",
      "VX Deluxe",
      "VX Limited",
      "VXR",
      "VXS"
    ],

    2014: [
      "FX Cruiser SVHO",
      "FX SVHO",
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "FZR",
      "FZS",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Limited",
      "VXR",
      "VXS"
    ],

    2013: [
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "FZR",
      "FZS",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Limited",
      "VXR",
      "VXS"
    ],

    2012: [
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "FZR",
      "FZS",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Sport",
      "VXR",
      "VXS"
    ],

    2011: [
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Sport",
      "VXR",
      "VXS"
    ],

    2010: [
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "FZR",
      "FZS",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Sport"
    ],

    2009: [
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "FZR",
      "FZS",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Sport"
    ],

    2008: [
      "FX Cruiser SHO",
      "FX SHO",
      "FX Cruiser HO",
      "FX HO",
      "GP1300R",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Sport"
    ],

    2007: [
      "FX Cruiser HO",
      "FX HO",
      "GP1300R",
      "SuperJet",
      "VX",
      "VX-C",
      "VX Cruiser",
      "VX Deluxe",
      "VX Sport"
    ],

    2006: [
      "FX Cruiser HO",
      "FX HO",
      "GP1300R",
      "SuperJet",
      "VX110 Deluxe",
      "VX110 Sport",
      "VX700"
    ],

    2005: [
      "FX Cruiser HO",
      "FX HO",
      "FX140",
      "GP1300R",
      "GP1200R",
      "SuperJet",
      "XLT1200",
      "XLT800",
      "VX110 Deluxe",
      "VX110 Sport"
    ],

    2004: [
      "FX140 HO",
      "FX140",
      "GP1300R",
      "GP1200R",
      "SuperJet",
      "XLT1200",
      "XLT800",
      "XL700"
    ],

    2003: [
      "FX140",
      "GP1300R",
      "GP1200R",
      "SuperJet",
      "XLT1200",
      "XLT800",
      "XL700"
    ],

    2002: [
      "GP1300R",
      "GP1200R",
      "GP800R",
      "SuperJet",
      "XLT1200",
      "XLT800",
      "XL700",
      "AR210"
    ],

    2001: [
      "GP1200R",
      "GP800R",
      "GP760",
      "SuperJet",
      "XLT1200",
      "XLT800",
      "XL700",
      "AR210"
    ],

    2000: [
      "GP1200R",
      "GP800",
      "GP760",
      "SuperJet",
      "XLT1200",
      "XL1200 Limited",
      "XL700",
      "AR210"
    ]

  },

  "Sea-Doo": {

    2025: [
      "RXP-X 325",
      "RXT-X 325",
      "GTX Limited 325",
      "GTX 170",
      "GTI SE 170",
      "GTI 130",
      "Wake Pro 230",
      "Spark Trixx",
      "FishPro Trophy",
      "Switch"
    ],

    2024: [
      "RXP-X 325",
      "RXT-X 325",
      "GTX Limited 325",
      "GTX 170",
      "GTI SE 170",
      "GTI 130",
      "Wake Pro 230",
      "Spark Trixx",
      "FishPro Trophy",
      "Switch"
    ],

    2023: [
      "RXP-X 300",
      "RXT-X 300",
      "GTX Limited 300",
      "GTX 170",
      "GTI SE 170",
      "GTI 130",
      "Wake Pro 230",
      "Spark Trixx",
      "FishPro Trophy",
      "Switch"
    ],

    2022: [
      "RXP-X 300",
      "RXT-X 300",
      "GTX Limited 300",
      "GTX 170",
      "GTI SE 170",
      "GTI 130",
      "Wake Pro 230",
      "Spark Trixx",
      "FishPro Trophy",
      "Switch"
    ],

    2021: [
      "RXP-X 300",
      "RXT-X 300",
      "GTX Limited 300",
      "GTX 170",
      "GTI SE 170",
      "GTI 130",
      "Wake Pro 230",
      "Spark Trixx",
      "FishPro Scout"
    ],

    2020: [
      "RXP-X 300",
      "RXT-X 300",
      "GTX Limited 230",
      "GTX 300",
      "GTI SE 170",
      "GTI 130",
      "GTR 230",
      "Wake Pro 230",
      "Spark Trixx",
      "FishPro"
    ],

    2019: [
      "RXP-X 300",
      "RXP 260",
      "RXT-X 300",
      "RXT 230",
      "GTX Limited 300",
      "GTX 230",
      "GTI SE 155",
      "GTI 130",
      "GTR 230",
      "GTR-X 230",
      "Wake Pro 230",
      "Spark Trixx",
      "Spark 2up",
      "FishPro"
    ],

    2018: [
      "RXP-X 300",
      "RXP 260",
      "RXT-X 300",
      "RXT 230",
      "GTX Limited 300",
      "GTX 155",
      "GTI SE 155",
      "GTI 130",
      "GTR 230",
      "Wake Pro 215",
      "Spark Trixx",
      "Spark 2up"
    ],

    2017: [
      "RXP-X 300",
      "RXP-X 260",
      "RXT-X 300",
      "RXT 230",
      "GTX Limited 300",
      "GTX 155",
      "GTI SE 155",
      "GTI 130",
      "GTR 230",
      "GTR-X 230",
      "Wake 155",
      "Spark Trixx",
      "Spark 2up",
      "Spark 3up"
    ],

    2016: [
      "RXP-X 260",
      "RXT-X 300",
      "RXT 230",
      "GTX Limited 215",
      "GTX SE 155",
      "GTX 155",
      "GTX Limited iS 215",
      "GTI SE 155",
      "GTI 130",
      "GTR 230",
      "Wake Pro 215",
      "Spark 2up",
      "Spark 3up"
    ],

    2015: [
      "RXP-X 260",
      "RXT-X 260",
      "RXT 260",
      "GTX Limited 215",
      "GTX SE 155",
      "GTX 155",
      "GTX Limited iS 215",
      "GTI SE 155",
      "GTI 130",
      "GTR 215",
      "Wake Pro 215",
      "Spark 2up",
      "Spark 3up"
    ],

    2014: [
      "RXP-X 260",
      "RXT-X 260",
      "RXT 260",
      "GTX Limited 215",
      "GTX SE 155",
      "GTX 155",
      "GTX Limited iS 215",
      "GTI SE 155",
      "GTI 130",
      "GTR 215",
      "Wake Pro 215"
    ],

    2013: [
      "RXP-X 260",
      "RXT-X 260",
      "RXT 260",
      "GTX Limited 215",
      "GTX SE 155",
      "GTX 155",
      "GTX Limited iS 215",
      "GTI SE 155",
      "GTI 130",
      "GTR 215",
      "Wake Pro 215"
    ],

    2012: [
      "RXP-X 260",
      "RXT-X 260",
      "RXT 260",
      "GTX Limited 215",
      "GTX SE 155",
      "GTX 155",
      "GTX Limited iS 215",
      "GTI SE 155",
      "GTI 130",
      "GTR 215",
      "Wake Pro 215"
    ],

    2011: [
      "RXP-X 255",
      "RXP 215",
      "RXT-X 260",
      "RXT 260",
      "GTX Limited 215",
      "GTX SE 155",
      "GTX 155",
      "GTX Limited iS 215",
      "GTI SE 155",
      "GTI SE 130",
      "GTI 130",
      "GTS 130",
      "Wake Pro 215"
    ],

    2010: [
      "RXP-X 255",
      "RXP 215",
      "RXT-X 260",
      "RXT 215",
      "GTX Limited 215",
      "GTX SE 155",
      "GTX 155",
      "GTX Limited iS 215",
      "GTI SE 155",
      "GTI SE 130",
      "GTI 130",
      "Wake 215"
    ],

    2009: [
      "RXP-X 255",
      "RXP 215",
      "RXT-X 255",
      "RXT 215",
      "GTX Limited 215",
      "GTX 155",
      "GTI SE 155",
      "GTI SE 130",
      "GTI 130",
      "Wake 215"
    ],

    2008: [
      "RXP-X 255",
      "RXP 215",
      "RXP 155",
      "RXT-X 255",
      "RXT 215",
      "GTX Limited 215",
      "GTX 155",
      "GTI SE 155",
      "GTI SE 130",
      "GTI 130",
      "Wake 215"
    ],

    2007: [
      "RXP 215",
      "RXP 155",
      "RXT 215",
      "GTX Limited 215",
      "GTX 155",
      "GTI SE 155",
      "GTI SE 130",
      "GTI 130",
      "Wake 215"
    ],





    
    2006: [
      "RXP 215",
      "RXT 215",
      "GTX Limited 215",
      "GTX 155",
      "GTI SE 130",
      "GTI 130",
      "Wake 155",
      "GTX 4-TEC",
    ],



    2005: [
      "RXP 215",
      "RXT 215",
      "GTX Limited 215",
      "GTX 4-TEC",
      "GTI LE RFI",
      "GTI RFI",
      "GTI",
      "3D RFI",
      "3D DI",
      "Sportster 4-TEC",
      "Sportster LE DI"
    ],

    2004: [
      "RXP 215",
      "GTX Limited",
      "GTX 4-TEC",
      "GTX SC",
      "GTI LE RFI",
      "GTI RFI",
      "GTI",
      "3D RFI",
      "3D DI",
      "Sportster 4-TEC",
      "Sportster LE DI",
      "XP DI"
    ],

    2003: [
      "GTX Limited",
      "GTX 4-TEC",
      "GTX SC",
      "GTI LE RFI",
      "GTI RFI",
      "GTI",
      "XP DI",
      "Sportster 4-TEC",
      "Sportster LE DI",
      "LRV DI"
    ],

    2002: [
      "GTX Limited",
      "GTX DI",
      "GTI LE RFI",
      "GTX 4-TEC",
      "GTI RFI",
      "GTI",
      "XP DI",
      "Sportster DI",
      "Sportster LE DI",
      "LRV DI",
      "3D"


    ],

    2001: [
      "GTX Limited",
      "GTX DI",
      "GTI LE",
      "GTI",
      "XP",
      "Sportster DI",
      "Sportster LE",
      "LRV",
      "GTS"
    ],

    2000: [
      "GTX Limited",
      "GTX DI",
      "GTI LE",
      "GTI",
      "XP",
      "Sportster DI",
      "Sportster LE",
      "LRV",
      "GTS",
      "SPX"
    ],


    1999: [
  "GTX Limited",
  "GTI LE",
  "GTI",
  "XP",
  "SPX",
  "GTS",
  "HX"
],

1998: [
  "GTX Limited",
  "GTI LE",
  "GTI",
  "XP",
  "SPX",
  "GTS",
  "HX"
],

1997: [
  "GTX Limited",
  "GTI",
  "XP",
  "SPX",
  "GTS",
  "HX"
],


  },

  Kawasaki: {

    2025: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra 160LX-S",
      "STX 160",
      "STX 160LX",
      "STX 160X"
    ],

    2024: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra 160LX-S",
      "STX 160",
      "STX 160LX",
      "STX 160X"
    ],

    2023: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 160",
      "STX 160LX",
      "STX 160X"
    ],

    2022: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 160",
      "STX 160LX",
      "STX 160X"
    ],

    2021: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 160",
      "STX 160LX",
      "STX 160X"
    ],

    2020: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 160",
      "STX 160LX",
      "STX 160X"
    ],

    2019: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 160",
      "STX 160LX",
      "STX 160X"
    ],

    2018: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 15F"
    ],

    2017: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 15F"
    ],

    2016: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 15F"
    ],

    2015: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 15F"
    ],

    2014: [
      "Ultra 310LX",
      "Ultra 310X",
      "Ultra LX",
      "STX 15F"
    ],

    2013: [
      "Ultra 300LX",
      "Ultra 300X",
      "Ultra LX",
      "STX 15F"
    ],

    2012: [
      "Ultra 300LX",
      "Ultra 300X",
      "Ultra LX",
      "STX 15F"
    ],

    2011: [
      "Ultra 300LX",
      "Ultra 300X",
      "Ultra LX",
      "STX 15F"
    ],

    2010: [
      "Ultra 260LX",
      "Ultra 260X",
      "Ultra LX",
      "STX 15F"
    ],

    2009: [
      "Ultra 260LX",
      "Ultra 260X",
      "Ultra LX",
      "STX 15F"
    ],

    2008: [
      "Ultra 250X",
      "Ultra LX",
      "STX 15F",
      "STX 12F"
    ],

    2007: [
      "Ultra 250X",
      "Ultra LX",
      "STX 15F",
      "STX 12F"
    ],

    2006: [
      "Ultra 250X",
      "Ultra LX",
      "STX 15F",
      "STX 12F"
    ],

    2005: [
      "Ultra 150",
      "STX 15F",
      "STX 12F",
      "STX-R 1200",
      "STX 1200",
      "XI Sport"
    ],

    2004: [
      "Ultra 150",
      "STX 15F",
      "STX 12F",
      "STX-R 1200",
      "STX 1200",
      "XI Sport"
    ],

    2003: [
      "Ultra 130 DI",
      "STX 15F",
      "STX 12F",
      "STX-R 1200",
      "STX 1200",
      "XI Sport"
    ],

    2002: [
      "Ultra 130 DI",
      "STX 15F",
      "STX 12F",
      "STX-R 1200",
      "STX 1200",
      "XI Sport",
      "ZXi 1100",
      "ZXi 900"
    ],

    2001: [
      "Ultra 130 DI",
      "STX 12F",
      "STX 1200",
      "STX 900",
      "XI Sport",
      "ZXi 1100",
      "ZXi 900",
      "ZXi 750"
    ],

    2000: [
      "Ultra 150",
      "STX 1200",
      "STX 900",
      "XI Sport",
      "ZXi 1100",
      "ZXi 900",
      "ZXi 750",
      "SS Xi Sport"
    ]

  }

};